import { useEffect } from "react";
import { ShippingDetailsViewModelV2 } from "../../viewmodels/shipping/ShippingDetailsViewModelV2";

import { useParams } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import ShippingFormV2 from "../../components/forms/shipping/ShippingFormV2";

function ShippingDetailsV2(props) {
  const { addSnackbar, logout } = props;

  const { shippingId } = useParams();

  const {
    onFetchOrderItems,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateShippingApiCall,
    shipping,
    onFetchPackagedItemByBarcode,
    addPackagedItemToOrderItem,
    getShippingDetails,
    deleteShippingItemApiCall,
    addSkidLabelToOrderItem,
    employeeOptions,
    getEmployeesForDropdown,
    deleteShipping,
    printShipping,
    quickAddPackagedItemToOrderItem,
    deleteQuickScanShippingItemByLot,
    exportOrderForNetSuite,
    getOrderItemsOnly,
    rowDetails,
    fetchRowDetails,
    loadingRows,
    sunCustomers,
    getSunCustomersForDropdown,
    sendShippingToQuickbooks,
    printShippingLabel,
    calculateFreightWeight,
    generateBolDocument,
    generateBolNumber,
    updateOrderItemUnitCost
  } = ShippingDetailsViewModelV2(shippingId, logout, addSnackbar);

  const apiFunctionCalls = async function () {
    let callResult = await getEmployeesForDropdown([1, 2], [1, 5]);
    getSunCustomersForDropdown();
    if (callResult.success) {
      getShippingDetails();
    } else {
    }
  };

  useEffect(() => {
    apiFunctionCalls();
  }, []);

  return (
    <div>
      <div className="mt-2 pl-0 sm:px-4">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Shipment: {shipping ? shipping.order ? shipping.order.label : null : null}
            </h1>
          </div>
          <div className="mt-5">
            {shipping ? (
              <ShippingFormV2
                orders={[]}
                onFetchOrderItems={onFetchOrderItems}
                isEdit={true}
                setEmptyModelOpen={setEmptyModelOpen}
                showErrorModal={showErrorModal}
                updateShippingApiCall={updateShippingApiCall}
                shipping={shipping}
                onFetchPackagedItemByBarcode={onFetchPackagedItemByBarcode}
                addPackagedItemToOrderItem={addPackagedItemToOrderItem}
                deleteShippingItemApiCall={deleteShippingItemApiCall}
                addSkidLabelToOrderItem={addSkidLabelToOrderItem}
                employeeOptions={employeeOptions}
                deleteShipping={deleteShipping}
                printShipping={printShipping}
                quickAddPackagedItemToOrderItem={
                  quickAddPackagedItemToOrderItem
                }
                deleteQuickScanShippingItemByLot={
                  deleteQuickScanShippingItemByLot
                }
                exportOrderForNetSuite={exportOrderForNetSuite}
                getOrderItemsOnly={getOrderItemsOnly}
                rowDetails={rowDetails}
                fetchRowDetails={fetchRowDetails}
                loadingRows={loadingRows}
                sunCustomers={sunCustomers}
                sendShippingToQuickbooks={sendShippingToQuickbooks}
                printShippingLabel={printShippingLabel}
                calculateFreightWeight={calculateFreightWeight}
                generateBolDocument={generateBolDocument}
                generateBolNumber={generateBolNumber}
                updateOrderItemUnitCost={updateOrderItemUnitCost}
              />
            ) : null}
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingDetailsV2)
);
